

export default function NotificationItem({ displayText, timeElapsed }) {
  return (
    <div className={"flex flex-row items-center gap-2 p-4 [w-60 sm:w-80]"}>
      <div className={"rounded-full grid place-items-center"}>
        {/* <img
          className={"w-[30px] rounded-full object-cover"}
          src={bell_png}
          alt={"Bell"}
        /> */}
        <svg className="xs:size-5 sm:size-5 md:size-7 2xl:size-7" width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M17.4944 3.66602C11.0277 3.66602 8.21799 9.52157 8.21799 13.3924C8.21799 16.2855 8.63744 15.4341 7.03605 18.9632C5.08049 23.9924 12.9444 26.048 17.4944 26.048C22.043 26.048 29.9069 23.9924 27.9527 18.9632C26.3513 15.4341 26.7708 16.2855 26.7708 13.3924C26.7708 9.52157 23.9597 3.66602 17.4944 3.66602Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M20.8625 29.9141C18.975 32.0224 16.0306 32.0474 14.125 29.9141" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
      <div className={"flex flex-col gap-1"}>
        <p className={"text-light-brown-coffee text-sm sm:text-base line-clamp-2"}>
          {displayText}
        </p>
        <p className={"text-xs sm:text-sm text-granite-gray font-light"}>{timeElapsed} ago</p>
      </div>
    </div>
  );
}
